import { createContext } from 'react';

const SubCategoryContext = createContext();

export default SubCategoryContext; 